import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import styles from './AddDataSection.module.scss';


type Props = {
  sectionTitle: string,
  onClickHandler: () => void,
  btnText: string,
  isMultipleSections?: boolean
}

const AddDataSection = ({ sectionTitle, onClickHandler, btnText, isMultipleSections = false }: Props) => {

  return (
    <div className={styles.fieldsContainer}>
      <div className={`${styles.addDetailsRootContainer} ${isMultipleSections ? '' : styles.singleSection}`}>
        <div className={styles.leftContainer}>
          <div className={styles.title}>
            {sectionTitle}
          </div>
        </div>
        <div className={styles.rightContainer}>
          <MeritoButton
            btnText={btnText}
            type='primary-1'
            size='md'
            onClick={onClickHandler}
          />
        </div>
      </div>
    </div>
  );
}

export default AddDataSection;